import React, { createContext, useState, useContext} from 'react'

const AppContext = createContext();

export default function ContextProvider({ children }) {
    const [aviso, setAviso] = useState({ open: false, message: "", severity: "" })
    return (
        <AppContext.Provider
          value={{
            avisoContext: { aviso, setAviso}
          }}
        >
          {children}
        </AppContext.Provider>
      );
}

export function useAviso() {
    const { avisoContext } = useContext(AppContext);
    const { aviso, setAviso } = avisoContext
    return { aviso, setAviso }
}